import { AppProductLine as ProductLine } from 'graphql/models/extended';

export function getLineProductName(
  line: ProductLine
): string {
  return line.snkProductName ?? line.product.name;
}
